const GRANITE_HQ_ADDRESSES = [
  '100 newport ave extension quincy ma 02171',
  '100 newport ave ext. quincy ma 02171',
  '100 newport avenue extension quincy ma 02171',
  '100 newport avenue ext. quincy ma 02171',
  '1 heritage drive quincy ma 02171',
  '1 heritage dr quincy ma 02171',
];

export const INVOICE_PROCESSING_STATUS = [
  'default',
  'error',
  'no-better-offer',
  'address-verification',
  'failed-multi-site',
  'failed-multi-service',
  'failed-granite-invoice',
] as const;

export type InvoiceProcessingStatus =
  (typeof INVOICE_PROCESSING_STATUS)[number];

export const isGraniteHQAddress = (location?: {
  address1: string;
  address2?: string | null;
  city: string;
  state: string;
  zip_code: string;
}) => {
  if (!location) return false;

  const formatted =
    `${location.address1} ${location.city} ${location.state} ${location.zip_code}`
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  return GRANITE_HQ_ADDRESSES.some((hq) => formatted.includes(hq));
};

export const formatAddress = (location: {
  address1: string;
  address2?: string | null;
  city: string;
  state: string;
  zip_code: string;
}) =>
  [
    location.address1,
    location.address2,
    location.city,
    `${location.state} ${location.zip_code}`.trim(),
  ]
    .filter(Boolean)
    .join(', ');
